// Card.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/card.css";

const Card = ({
  image,
  title,
  description,
  learn,
  to,
  showButton = true,
  icon,
}) => {
  const navigate = useNavigate();

  const onButtonClick = () => {
    if (to) {
      navigate(to);
    }
  };

  return (
    <div className="card-container">
      <div className="card">
        <div className="card-image-container">
          <img
            src={image || "/placeholder.jpg"}
            alt={title || "Card image"}
            className="prop-image"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/placeholder.jpg";
            }}
          />
          <div className="card-overlay">
            <div className="card-content">
              {icon && (
                <div className="card-icon">
                  <img src={icon} alt={`${title} icon`} />
                </div>
              )}
              <h3>{title}</h3>
              <div className="card-description">
                {description.split("/n").map((line, index) => (
                  <p key={index}>{line.trim()}</p>
                ))}
              </div>
              <div className="divider"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
